import { fromSeoUrl, toSingular } from 'helpers/HelperFunctions';
import toSentenceCase from 'helpers/sentenceCase';

/**
 * Results-area H2 copy for the jobs board.
 * Page H1 stays in ProjectsHeader; this is the heading under the search bar.
 */
export default function getJobsResultsHeading({
  pageType,
  filterCount = 0,
  selectedRoleName = '',
  country = null,
  city = null,
}) {
  if (pageType === 'role' && selectedRoleName) {
    return `${toSentenceCase(toSingular(selectedRoleName))} jobs`;
  }

  if (pageType === 'country') {
    if (!country && !city) {
      return 'Latest jobs';
    }
    const place = city
      ? `${fromSeoUrl(city)}${country ? `, ${fromSeoUrl(country)}` : ''}`
      : fromSeoUrl(country);
    return place ? `Jobs in ${place}` : 'Latest jobs';
  }

  if (filterCount > 0) {
    return 'Jobs that fit your filters';
  }

  return 'Latest jobs';
}
